const steps = [
  {
    n: "01",
    icon: "ri-phone-line",
    title: "상담 및 현장 확인",
    desc: "현장 위치, 물량, 원하시는 칩 사이즈를 확인하고 필요 시 사전 방문을 진행합니다.",
  },
  {
    n: "02",
    icon: "ri-map-2-line",
    title: "장비 투입 계획",
    desc: "이동 경로, 진입로, 작업 공간과 안전 조건에 맞춰 장비 투입 일정을 확정합니다.",
  },
  {
    n: "03",
    icon: "ri-tools-line",
    title: "현장 파쇄 작업",
    desc: "스크린 규격에 맞춘 원목칩·가지칩 파쇄와 뿌리 그라인딩을 안정적인 출력으로 진행합니다.",
  },
  {
    n: "04",
    icon: "ri-truck-line",
    title: "정리 및 이송",
    desc: "생산된 칩의 적재·운반·판매 채널 연결까지 필요에 맞춰 마무리 지원합니다.",
  },
];

import ScrollReveal from "@/components/ScrollReveal";
import { resolveImageUrl } from "@/lib/api";

export default function Process() {
  return (
    <section className="relative py-24 md:py-32 bg-primary-950 overflow-hidden">
      <div className="absolute inset-0 opacity-20">
        <img
          src={resolveImageUrl("/uploads/home-process.jpg")}
          alt="공정 섹션 배경"
          className="w-full h-full object-cover object-top"
        />
      </div>
      <div className="absolute inset-0 bg-primary-950/85"></div>

      <div className="relative max-w-7xl mx-auto px-6 md:px-10">
        <div className="max-w-3xl">
          <ScrollReveal direction="up" delay={100}>
            <div className="inline-flex items-center gap-2 text-accent-300 text-xs tracking-[0.3em] uppercase font-medium mb-5">
              <span className="w-8 h-px bg-accent-400"></span>
              Working Process
            </div>
            <h2 className="font-heading text-4xl md:text-5xl font-bold text-background-50 leading-tight">
              상담부터 마무리까지,
              <br />
              <span className="text-accent-300">한 팀이 책임집니다.</span>
            </h2>
            <p className="mt-6 text-background-100 text-base md:text-lg leading-relaxed">
              현장 조건 확인, 스크린 계획, 장비 투입, 파쇄 작업, 이송까지 &mdash;
              우공이산의 표준 작업 프로세스로 예측 가능한 결과를 만듭니다.
            </p>
          </ScrollReveal>
        </div>

        <div className="mt-16 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
          {steps.map((s, i) => (
            <ScrollReveal key={s.n} direction="up" delay={150 + i * 150}>
              <div className="relative p-7 rounded-lg bg-background-50/5 backdrop-blur border border-background-50/10 hover:border-accent-500/60 transition-colors group h-full">
                <div className="flex items-center justify-between mb-6">
                  <div className="w-12 h-12 rounded-md bg-accent-500 flex items-center justify-center">
                    <i className={`${s.icon} text-background-50 dark:text-foreground-950 text-xl w-6 h-6 flex items-center justify-center`}></i>
                  </div>
                  <span className="font-heading text-4xl font-bold text-background-50/20 group-hover:text-accent-300/60 transition-colors">
                    {s.n}
                  </span>
                </div>
                <div className="font-heading text-xl font-semibold text-background-50">
                  {s.title}
                </div>
                <p className="mt-3 text-background-100/80 text-sm leading-relaxed">
                  {s.desc}
                </p>
                {i < steps.length - 1 && (
                  <div className="hidden lg:block absolute -right-3 top-1/2 -translate-y-1/2 text-background-50/30">
                    <i className="ri-arrow-right-s-line text-3xl"></i>
                  </div>
                )}
              </div>
            </ScrollReveal>
          ))}
        </div>
      </div>
    </section>
  );
}